if (!customElements.get("variant-selects")) {
  customElements.define(
    "variant-selects",
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
        this.addEventListener("change", this.onVariantChange);
      }

      connectedCallback() {
        if (window.location.search.includes("variant=")) {
          setTimeout(() => {
            const selects = this.querySelectorAll("select");
            selects.forEach((select) => {
              const selectedOption = select.querySelector("option[selected]");
              if (selectedOption) {
                select.value = selectedOption.value;
                select.dispatchEvent(new Event("input", { bubbles: true }));
                select.dispatchEvent(new Event("change", { bubbles: true }));
              }
            });
          }, 100);
        }
      }

      onVariantChange() {
        this.updateOptions();
        this.getCurrentVariant();
        this.toggleAddButton(true, "", false);
        this.toggleBackinstockForm();
        this.toggleInventoryQuantity();
        this.toggleQuantitySelector();

        if (!this.currentVariant) {
          this.toggleAddButton(true, "", true);
        } else {
          this.updateURL();
          this.updateVariantInput();
          this.renderProductInfo();
        }
      }

      getVariantData() {
        this.variantData =
          this.variantData ||
          JSON.parse(
            this.querySelector('[type="application/json"]').textContent
          );
        return this.variantData;
      }

      updateOptions() {
        this.options = Array.from(
          this.querySelectorAll("select"),
          (select) => select.value
        );
      }

      getCurrentVariant() {
        this.currentVariant = this.getVariantData().find((variant) => {
          return !variant.options
            .map((option, index) => {
              return this.options[index] === option;
            })
            .includes(false);
        });
      }

      updateURL() {
        if (!this.currentVariant) return;
        window.history.replaceState(
          {},
          "",
          `${this.dataset.url}?variant=${this.currentVariant.id}`
        );
      }

      renderProductInfo() {
        fetch(
          `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
        )
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );

            const destinationPrice = document.getElementById(
              `price-${this.dataset.section}`
            );
            const sourcePrice = html.getElementById(
              `price-${this.dataset.section}`
            );
            if (sourcePrice && destinationPrice)
              destinationPrice.innerHTML = sourcePrice.innerHTML;

            const destinationSku = document.getElementById(
              `sku-${this.dataset.section}`
            );
            const sourceSku = html.getElementById(
              `sku-${this.dataset.section}`
            );
            if (sourceSku && destinationSku)
              destinationSku.innerHTML = sourceSku.innerHTML;

            this.toggleAddButton(
              !this.currentVariant.available,
              window.variantStrings.soldOut
            );

            // ✅ Inject correct variant ID into the re-rendered form
            const form = document.querySelector(
              `#product-form-${this.dataset.section}`
            );
            if (form) {
              const idInput = form.querySelector('input[name="id"]');
              if (idInput) {
                idInput.value = this.currentVariant.id;
                idInput.dispatchEvent(
                  new Event("change", { bubbles: true })
                );
              }
            }
          });
      }

      toggleAddButton(disable = true, text, modifyClass = true) {
        const addButton = document.querySelector('[name="add"]');
        const addButtonText = document.querySelector('[name="add"] > span');
        if (!addButton) return;

        if (disable) {
          addButton.setAttribute("disabled", "disabled");
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute("disabled");
          addButtonText.textContent = window.variantStrings.addToCart;
        }

        if (!modifyClass) return;
      }

      updateVariantInput() {
        const productForms = document.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-backinstock-${this.dataset.section}`
        );
        productForms.forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          if (input) {
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event("change", { bubbles: true }));
          }
        });
      }

      toggleBackinstockForm() {
        const backinstockForm = document.querySelector(
          `#product-form-backinstock-${this.dataset.section}`
        );
        if (!backinstockForm) return;

        if (this.currentVariant && this.currentVariant.available) {
          backinstockForm.classList.add("hidden");
        } else {
          backinstockForm.classList.remove("hidden");
        }
      }

      toggleQuantitySelector() {
        const quantitySelector = document.querySelector(
          `#quantity-selector-${this.dataset.section}`
        );
        if (!quantitySelector) return;

        if (
          this.currentVariant &&
          (!this.currentVariant.available ||
            this.currentVariant.inventory_quantity === 0)
        ) {
          quantitySelector.classList.add("md:hidden");
        } else {
          quantitySelector.classList.remove("md:hidden");
        }
      }

      toggleInventoryQuantity() {
        const inventoryQuantity = document.querySelector(
          `#inventory-quantity-${this.dataset.section}`
        );
        const inventoryQuantityText = document.querySelector(
          `#inventory-quantity-${this.dataset.section} > span`
        );
        if (!inventoryQuantity) return;

        if (
          this.currentVariant &&
          (this.currentVariant.inventory_quantity === 0 ||
            this.currentVariant.inventory_quantity > 4)
        ) {
          inventoryQuantity.classList.add("hidden");
        } else {
          inventoryQuantity.classList.remove("hidden");
          inventoryQuantityText.textContent =
            this.currentVariant.inventory_quantity;
        }
      }
    }
  );
}
